import ptTranslations from './pt';
import enTranslations from './en';

export default {
  pt: ptTranslations,
  en: enTranslations
};
